import type { PlatformInvitation } from "@/api/platformInvitations";
import type { PlatformChurchDetail } from "@/api/platform";

import { InvitationDetailsPanel } from "@/components/platform/invitations/InvitationDetailsPanel";

type Props = {
  church: PlatformChurchDetail;
};

export function ChurchInvitationsPanel({
  church,
}: Props) {
  if (!church.invitation) {
    return (
      <InvitationDetailsPanel
        invitation={null}
      />
    );
  }

  const invitation: PlatformInvitation = {
    id: church.invitation.id,

    church_id: church.church.id,
    church_name: church.church.name,
    church_slug: church.church.slug,

    invited_email: church.invitation.invited_email,
    invited_first_name:
      church.invitation.invited_first_name,
    invited_last_name:
      church.invitation.invited_last_name,

    role_code: church.invitation.role_code,

    invitation_type: "PILOT_CHURCH_ADMIN",
    invitation_version: 1,

    status: church.invitation.status,

    send_count: church.invitation.send_count,

    sent_at: church.invitation.sent_at,
    last_sent_at:
      church.invitation.last_sent_at,

    expires_at:
      church.invitation.expires_at,

    accepted_at:
      church.invitation.accepted_at,

    revoked_at:
      church.invitation.revoked_at,

    revocation_reason: null,

    created_at:
      church.invitation.created_at,

    updated_at:
      church.invitation.updated_at,
  };

  return (
    <InvitationDetailsPanel
      invitation={invitation}
    />
  );
}